import { useHistory } from 'react-router'

import { SHIPPING_STATUS_CODES } from '../../../common/constants'
import useTranslations from '../../../i18n/useTranslations'
import * as routes from '../../../routes'

const useHomeTableActions = (shippings, filters, tabValue) => {
  const t = useTranslations()
  const history = useHistory()

  const goToShippingsTrackingFiltered = () => {
    const serializedCentres = Array.isArray(filters.centres)
          ? filters.centres.map(centre => centre.hideId).join(',')
          : filters.centres
    filters.centres=serializedCentres
    const shippingsTrackingFilters = { ...filters, rowsPerPage: '10' }
    
    // REVIEW this is a quick fix to avoid being redirected to the shippings
    // tracking page with some status code applied.
    // This might be the right solution, but I did not have time to inspect all
    // the code related to how the filters are being applied.
    delete shippingsTrackingFilters.statusCode

    const trackingPath = routes.generateQueryPath(
      routes.SHIPPINGS_TRACKING.path,
      shippingsTrackingFilters,
    )
    history.push(trackingPath)
  }

  const getSplitButtonOptions = () => {
    const isAnyShippingSelected = shippings?.length > 0

    const ACTIONS_CONFIG = {
      seeAll: {
        text: t('home:view-complete-list'),
        onClick: () => history.push(routes.SHIPPINGS_TRACKING.linkTo()),
      },
      seeMore: {
        text: t('home:view-complete-list'),
        onClick: goToShippingsTrackingFiltered,
      },
    }

    const actionsOnStatusCodes =
      isAnyShippingSelected && tabValue !== SHIPPING_STATUS_CODES.incidents
        ? ['seeMore']
        : tabValue === SHIPPING_STATUS_CODES.incidents
        ? ['seeAll']
        : ['seeMore']

    return actionsOnStatusCodes.map(action => ACTIONS_CONFIG[action])
  }

  const splitButtonOptions = getSplitButtonOptions()

  return {
    splitButtonOptions,
  }
}

export default useHomeTableActions
